import WaitingRoom from './WaitingRoom';

import beepAudio from '../../assets/sounds/beep.mp3';
import TelemedicineContext from '../../context/telemedicine';

import { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import useSound from 'use-sound';

const TwilioWaitingRoomContainer = () => {
	const navigate = useNavigate();
	const [play] = useSound(beepAudio, { volume: 1 });
	const { telemedicine, updateTelemedicine } = useContext(TelemedicineContext);

	useEffect(() => {
		const handleStartVideoCall = async room => {
			await play();

			updateTelemedicine({
				room_sid: room.room_sid,
				room_token: room.token
			});

			navigate('/video-room');
		};

		window.socket.on('telemedicine:start-video-call', handleStartVideoCall);

		window.socket.emit('telemedicine:enter-room', {
			room_id: telemedicine.id,
			patient_id: telemedicine.patient_id
		});

		return () => {
			window.socket.off('telemedicine:start-video-call', handleStartVideoCall);
		};
	}, [play, navigate, telemedicine, updateTelemedicine]);

	return (
		<WaitingRoom
			attendance={telemedicine.attendance}
			company={telemedicine.company}
			user={telemedicine.user}
		/>
	);
};

export default TwilioWaitingRoomContainer;
